<template>
  <div class="pdf-container">
    <!-- 控制栏 -->
    <div class="controls">
      <button 
        @click="prevPage"
        :disabled="pageNum <= 1"
        class="control-btn"
      >
        ← 上一页
      </button>
      
      <span class="page-info">
        第 {{ pageNum }} 页 / 共 {{ pageCount }} 页
      </span>

      <button 
        @click="nextPage"
        :disabled="pageNum >= pageCount"
        class="control-btn"
      >
        下一页 →
      </button>
    </div>

    <!-- PDF展示区域 -->
    <div v-if="error" class="error-message">
      PDF加载失败: {{ error }}
    </div>

    <div v-else-if="!loaded" class="loading">
      <div class="spinner"></div>
      正在加载PDF...
    </div>

    <div v-else class="pdf-wrapper">
      <pdf 
        :src="pdfDoc" 
        :page="pageNum"
        @num-pages="pageCount = $event"
        @loaded="loaded = true"
        @error="handleError"
      />
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf'

export default {
  props: ['url'],  // 接收PDF文件URL
  
  components: { pdf },

  data() {
    return {
      pdfDoc: null,    // PDF文档实例
      pageNum: 1,      // 当前页码
      pageCount: 0,    // 总页数
      loaded: false,   // 加载状态
      error: null      // 错误信息
    }
  },

  watch: {
    // 监听URL变化重新加载
    url: {
      immediate: true,
      handler(newUrl) {
        this.loadPdf(newUrl)
      }
    }
  },

  methods: {
    // 初始化PDF加载
    loadPdf(url) {
      console.log('url', url)
      this.resetState()
      
      if (!url) return

      try {
        this.pdfDoc = pdf.createLoadingTask({
          url,
          cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.6.347/cmaps/',
          cMapPacked: true
        })

        // 绑定错误处理
        this.pdfDoc.promise.catch(this.handleError)
      } catch (err) {
        this.handleError(err)
      }
    },

    // 重置状态
    resetState() {
      this.pageNum = 1
      this.pageCount = 0
      this.loaded = false
      this.error = null
      if (this.pdfDoc) this.pdfDoc.destroy()
    },

    // 错误处理
    handleError(err) {
      console.error('PDF Error:', err)
      this.error = err.message || '无法加载PDF文件'
      this.loaded = false
      this.$emit('error', err)
    },

    // 翻页方法
    prevPage() {
      if (this.pageNum > 1) this.pageNum--
    },

    nextPage() {
      if (this.pageNum < this.pageCount) this.pageNum++
    }
  },

  beforeDestroy() {
    // 组件销毁时清理资源
    if (this.pdfDoc) this.pdfDoc.destroy()
  }
}
</script>

<style scoped>
.pdf-container {
  max-width: 1000px;
  margin: 20px auto;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  background: white;
}

.controls {
  padding: 15px;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  border-bottom: 1px solid #ddd;
}

.control-btn {
  padding: 8px 20px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.3s;
}

.control-btn:disabled {
  background: #6c757d;
  cursor: not-allowed;
}

.control-btn:hover:not(:disabled) {
  background: #0056b3;
}

.page-info {
  font-size: 14px;
  color: #666;
}

.pdf-wrapper {
  padding: 20px;
  min-height: 500px;
  display: flex;
  justify-content: center;
  background: #f9f9f9;
}

.loading {
  padding: 50px;
  text-align: center;
  color: #666;
}

.spinner {
  display: inline-block;
  width: 30px;
  height: 30px;
  border: 3px solid #ddd;
  border-radius: 50%;
  border-top-color: #007bff;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.error-message {
  padding: 30px;
  color: #dc3545;
  background: #fff5f5;
  text-align: center;
}
</style>